import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Paper } from '@mui/material';

import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import FailedEmailList from './FailedEmailList';
import { MetricItem, Metrics } from '../dataObjects/MailgunMetricsResponse';
import EmailServerTotalStats from './EmailServerTotalStats';
import EmailServerDailyLineChart from './EmailServerDailyLineChart';

const EmailServer = () => {

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalStats, setTotalStats] = useState<Metrics>();
    const [dailyCount, setDailyCount] = useState<MetricItem[]>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    useEffect(() => {
        getMailgunMetrics();
    }, []);

    const getMailgunMetrics = async () => {
        await fetch(`/ItDashboard/getMailgunMetrics`)
            .then(result => result.json())
            .then(result => {
                if (!result.success) {
                    let info = {
                        type: 'error',
                        title: 'Error: ItDashboard - GetMailgunMetrics',
                        errorMessage: result.message,
                        secondaryErrorMessage: ''
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                    setIsLoading(false);
                }
                else {
                    setIsLoading(false);
                    setTotalStats(result.result.aggregates.metrics);
                    setDailyCount(result.result.items);
                }
            }
            )
    }

    return (
        <Grid container sx={{ display: 'flex' }} justifyContent="center">
            <Grid item xs={12}>
                <Typography component="h6" variant="h6" sx={{mt: 2 }}>
                    OCPF Mailgun Email Server
                </Typography>
            </Grid>
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                <Grid item xs={12}>
                    <Typography sx={{ mb: 1, mt: 2 }} color={'primary'} variant="subtitle1">
                        Email Stats in the last 30 days
                    </Typography>
                </Grid>
                <Grid item xs={12} component={Paper} padding={2} >
                    <EmailServerTotalStats metrics={totalStats} ></EmailServerTotalStats>
                    <EmailServerDailyLineChart items={dailyCount} ></EmailServerDailyLineChart>
                </Grid>
            </Grid>
            <Grid item xs={12} marginTop={2} >
                <FailedEmailList></FailedEmailList>
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </Grid>
    );
}

export default EmailServer;
